import ReactECharts from "echarts-for-react";

export default function NightingaleChart({ data, heading, h }) {
  const options = {
    title: {
      text: heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    legend: {
      top: "bottom",
      show: false,
    },
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c} ({d}%)",
    },
    label: {
      show: true,
      formatter: "{b}({d}%)",
    },
    series: [
      {
        name: heading,
        type: "pie",
        radius: [20, 70],
        center: ["50%", "57%"],
        roseType: "radius",
        itemStyle: {
          borderRadius: 5,
        },
        data: data,
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: `${h}px` }} />;
}
